import { useDispatch, useSelector, useStore } from 'react-redux';

import type { AppDispatch, RootState, store } from '../store';

export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();
export const useAppReduxStore = useStore.withTypes<typeof store>();
